<template>
    <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4 sz-dropdown" :class="[isMobile ? 'w-100' : 'w-30']"
        aria-labelledby="dropdownMenuButton">
        <div class="font-weight-bolder" style="text-align: center;">
            {{ contractData ? contractData.nome + ' - ' + contractData.contrato_unidade : null }}
        </div>
        <div v-if="loading" class="d-flex justify-content-center mt-2 custom-notification sz-dropdown">
            <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
        </div>
        <div v-else>
            <li v-for="(notification, index) in notifications" :key="notification.client_notification_id"
                class="mb-2 mt-2">
                <a v-if="index < 5" class="dropdown-item border-radius-md" href="#">
                    <div class="py-1 d-flex">
                        <div class="my-auto">
                            <i class="fa fa-bell fa-3x me-3" aria-hidden="true"></i>
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-1 text-sm font-weight-normal">
                                <span class="font-weight-bold">{{ notification.notification_html }}</span><br>
                                <span>{{ notification.notification }}</span>
                            </h6>
                            <p class="mb-0 text-xs text-secondary opacity-6">
                                <i class="fa fa-clock me-1"></i>
                                {{ formatRelativeTime(notification.created_at) }}
                            </p>
                        </div>
                    </div>
                </a>
            </li>
        </div>
        <div v-if="!loading && notifications && notifications.length === 0"
            class="d-flex font-weight-bold my-auto justify-content-center dropdown-item mt-2 sz-dropdown">
            <span style="font-size: 15px;">Você não possui nenhuma notificação para essa unidade</span>
        </div>
        <div v-else class="d-flex my-auto justify-content-center cursor-pointer bg sz-dropdown"
            @click="toggleComponent('AllNotifications')">
            Ver mais
        </div>
    </ul>
</template>

<script setup>
import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from "vue"
import axios from 'axios'

const store = useStore();

const notifications = ref(null)
const loading = ref(false)
const isMobile = computed(() => window.innerWidth <= 576)

onMounted(() => {
    if (contractData.value.contrato_id) {
        getClientNotifications();
    }
});

const contractData = computed(() => store.getters.getCurrentContract);

const getClientNotifications = async () => {
    try {
        loading.value = true;
        const response = await axios.get(`/notification/${contractData.value.contrato_id}/contract`);
        notifications.value = response.data.data
    } catch (error) {
        console.log(error);
    } finally {
        // showToast('Dados Atualizado.', 'success');
        loading.value = false;
    }

};

const formatRelativeTime = (datetime) => {
    const providedDate = new Date(datetime);
    const difference = Date.now() - providedDate.getTime();
    const timeUnits = [
        { unit: "semana", seconds: 604800 },
        { unit: "dia", seconds: 86400 },
        { unit: "hora", seconds: 3600 },
        { unit: "minuto", seconds: 60 }
    ];

    for (const { unit, seconds } of timeUnits) {
        const unitDifference = Math.floor(difference / (1000 * seconds));
        if (unitDifference > 0) {
            return unitDifference === 1 ? `1 ${unit} atrás` : `${unitDifference} ${unit}s atrás`;
        }
    }

    const minutesDifference = Math.floor(difference / (1000 * 60));
    return `${minutesDifference} minutos atrás`;
};


const toggleComponent = (component) => {
    store.commit("updateComponent", component)
};

const watcherFunction = () => {
    return (newValue, oldValue) => {
        if (newValue && oldValue && typeof newValue === 'object' && typeof oldValue === 'object' && newValue.contrato_unidade !== oldValue.contrato_unidade) {
            getClientNotifications()
        }
    };
};
watch(contractData, watcherFunction());
</script>

<style>
.custom-notification {
    max-width: 33rem;
}

.dropdown-item {
    white-space: normal !important;
}

.bg:hover {
    transition: background-color 0.3s ease, color 0.3s ease;
    background-color: #E9ECEF;
    border-radius: 0.5rem;
}
</style>